import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bg-gray container-fix-padding" }
const _hoisted_2 = { class: "d-flex flex-wrap" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "vote-value" }
const _hoisted_5 = { class: "d-flex align-center justify-space-between" }
const _hoisted_6 = {
  key: 0,
  class: "private-question"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  class: "d-flex",
  dense: ""
}
const _hoisted_9 = { class: "p-1" }
const _hoisted_10 = { class: "px-2 title-truncate" }
const _hoisted_11 = { class: "d-flex" }
const _hoisted_12 = { class: "float-right d-flex" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "text-grey" }
const _hoisted_16 = { class: "d-flex" }
const _hoisted_17 = { class: "d-flex gap-2 mt-3" }
const _hoisted_18 = {
  id: "answers-section",
  class: "mb-4"
}
const _hoisted_19 = {
  key: 2,
  class: "mb-5 bg-white"
}
const _hoisted_20 = { class: "d-flex" }
const _hoisted_21 = { class: "vote-value" }
const _hoisted_22 = { class: "d-flex justify-end align-center gap-2 mb-3" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = {
  class: "d-flex",
  dense: ""
}
const _hoisted_27 = { class: "p-1" }
const _hoisted_28 = { class: "px-2 title-truncate" }
const _hoisted_29 = { class: "d-flex" }
const _hoisted_30 = { class: "d-flex gap-2 mt-3" }
const _hoisted_31 = { class: "d-flex" }
const _hoisted_32 = { class: "float-right d-flex" }
const _hoisted_33 = ["src"]
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "text-grey" }
const _hoisted_36 = { class: "d-flex" }
const _hoisted_37 = { class: "d-flex align-center ga-2" }

import { ref, computed, watch, onUpdated, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ROUTER_NAME } from '../../router'
import api from '../../../api/v2/api'
import UserQuestion from '../../../api/v2/models/user_question'
import UserAnswer from '../../../api/v2/models/user_answer'
import Comment from '../../../api/v2/models/comment'
import QuestionRelative from '../../../api/v2/models/question_relative'
import CommentForm from '../../../api/v2/forms/comment'
import AnswerForm from '../../../api/v2/forms/answer'
import VoteForm from '../../../api/v2/forms/vote'
import UserQuestionForm from '../../../api/v2/forms/user_question'
import ConfirmDialog from '../atoms_molecules/ConfirmDialog.vue'
import CommentComponent from '../atoms_molecules/Comment.vue'
import CommentCreation from '../atoms_molecules/CommentCreation.vue'
import FileIcon from '../atoms_molecules/FileIcon.vue'
import Simplemde from '../atoms_molecules/Simplemde.vue'
import { userState } from '../../stores/user'
import { checkMobile } from '../../utils/utils'
import { headerState } from '../../stores/header'
import { makeChannel, removeChannel } from '../../../../action_cable/cable'


export default /*@__PURE__*/_defineComponent({
  __name: 'UserQuestionDetail',
  setup(__props) {

const route = useRoute()
const router = useRouter()

// Refs
const confirmRef = ref<InstanceType<typeof ConfirmDialog> | null>(null)

// Reactive Data
const question = ref<UserQuestion | null>(null)
const newAnswer = ref('')
const answerFiles = ref<File[]>([])
const course = ref<QuestionRelative | null>(null)
const lesson = ref<QuestionRelative | null>(null)
const mobile = ref(checkMobile())
const channel = ref<any>(null)
const showSuccessSnackbar = ref(false)
const breadcrumbs = ref([
  {
    text: 'クラスルーム',
    disabled: false,
    exact: true,
    to: '/classroom/'
  },
  {
    text: 'マイ質問',
    disabled: false,
    exact: true,
    to: '/classroom/questions'
  }
])

// Computed
const user = computed(() => userState.user)

// Functions
async function getCurrentQuestion() {
  question.value = await api.userQuestion.show(route.params.questionId as string)
}

function stringTruncate(str: string, length: number): string {
  if (checkMobile()) {
    const dots = str.length > length ? '...' : ''
    return str.substring(0, length) + dots
  } else {
    return str
  }
}

async function createComment(newComment: string) {
  try {
    const commentForm = new CommentForm()
    commentForm.body = newComment
    commentForm.commentableId = parseInt(route.params.questionId as string)
    commentForm.commentableType = 'Question'
    await api.comment.create(commentForm)
    question.value = await api.userQuestion.show(route.params.questionId as string)
    if (question.value) {
      question.value.showCommentForm = false
    }
  } catch (e) {
    // Error handling
  }
}

async function createAnswerComment(newComment: string, answer: UserAnswer) {
  try {
    const commentForm = new CommentForm()
    commentForm.body = newComment
    commentForm.commentableId = answer.id
    commentForm.commentableType = 'Answer'
    await api.comment.create(commentForm)
    question.value = await api.userQuestion.show(route.params.questionId as string)
    answer.showCommentForm = false
  } catch (e) {
    // Error handling
  }
}

async function createAnswer() {
  try {
    const answerForm = new AnswerForm()
    answerForm.body = newAnswer.value
    answerForm.question_id = route.params.questionId as string
    answerForm.materials = answerFiles.value
    await api.answer.create(answerForm)

    // Clear form immediately
    newAnswer.value = ''
    answerFiles.value = []

    // Clear SimpleMDE from window global if exists
    if ((window as any).simplemde) {
      ;(window as any).simplemde.value('')
    }

    // Force update to ensure SimpleMDE re-renders with empty value
    await nextTick()

    // Show success notification first
    showSuccessSnackbar.value = true

    // Reload question to get new answer
    const updatedQuestion = await api.userQuestion.show(route.params.questionId as string)
    question.value = updatedQuestion

    // Wait for DOM update
    await nextTick()

    // Add small delay to ensure render is complete
    setTimeout(() => {
      // Scroll to "アンサー" section to show new answer
      const answersSection = document.getElementById('answers-section')
      if (answersSection) {
        const yOffset = -80
        const y = answersSection.getBoundingClientRect().top + window.pageYOffset + yOffset
        window.scrollTo({ top: y, behavior: 'smooth' })
      } else {
        // Fallback: scroll to top of answers list
        const answersList = document.querySelector('.answers-list')
        if (answersList) {
          answersList.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }
    }, 500)
  } catch (e) {
    console.error('Error creating answer:', e)
  }
}

async function updateQuestion(questionData: UserQuestion) {
  if (!question.value) return
  try {
    const questionForm = new UserQuestionForm()
    questionForm.body = question.value.body
    questionForm.questionType = question.value.questionType
    questionForm.materials = question.value.files
    await api.userQuestion.update(question.value.id, questionForm)

    question.value.files = []
    questionData.isEditing = false
    question.value = await api.userQuestion.show(route.params.questionId as string)
  } catch (e) {
    // Error handling
  }
}

async function updateAnswer(answer: UserAnswer) {
  try {
    const answerForm = new AnswerForm()
    answerForm.body = answer.body
    answerForm.materials = answer.files
    await api.answer.update(answer.id, answerForm)

    answer.files = []
    answer.isEditing = false
    question.value = await api.userQuestion.show(route.params.questionId as string)
  } catch (e) {
    // Error handling
  }
}

async function updateComment(comment: Comment) {
  try {
    await api.comment.update(comment.id, { body: comment.body })
    comment.isEditing = false
    question.value = await api.userQuestion.show(route.params.questionId as string)
  } catch (e) {
    // Error handling
  }
}

async function setBestAnswer(answer: UserAnswer, accepted: string) {
  try {
    const answerForm = new AnswerForm()
    answerForm.accepted = accepted
    await api.answer.update(answer.id, answerForm)

    answer.isEditing = false
    question.value = await api.userQuestion.show(route.params.questionId as string)
  } catch (e) {
    // Error handling
  }
}

async function deleteQuestion(questionId: number) {
  try {
    if (await confirmRef.value?.open('本当によろしいですか？')) {
      await api.userQuestion.delete(questionId.toString())
      router.replace({ name: ROUTER_NAME.MY_USER_QUESTION_LIST })
    }
  } catch (e) {
    // Error handling
  }
}

async function deleteAnswer(answerId: number) {
  try {
    if (await confirmRef.value?.open('本当によろしいですか？')) {
      await api.answer.delete(answerId)
      question.value = await api.userQuestion.show(route.params.questionId as string)
    }
  } catch (e) {
    // Error handling
  }
}

async function deleteComment(commentId: number) {
  try {
    if (await confirmRef.value?.open('本当によろしいですか？')) {
      await api.comment.delete(commentId)
      question.value = await api.userQuestion.show(route.params.questionId as string)
    }
  } catch (e) {
    // Error handling
  }
}

async function resolveQuestion() {
  try {
    if (await confirmRef.value?.open('この質問を解決済みにしますか？')) {
      await api.userQuestion.resolve(route.params.questionId as string)
      question.value = await api.userQuestion.show(route.params.questionId as string)
    }
  } catch (e) {
    console.error('Failed to resolve question:', e)
  }
}

async function upVote(voteMark: number, votableId: number, votableType: 'Question' | 'Answer' | 'Comment' | 'Course' | 'Lesson') {
  if (voteMark == 1) {
    return
  }
  try {
    const voteForm = new VoteForm()
    voteForm.value = Math.min(voteMark + 1, 1)
    voteForm.votableId = votableId
    voteForm.votableType = votableType
    await api.vote.create(voteForm)
    question.value = await api.userQuestion.show(route.params.questionId as string)
  } catch (e) {
    // Error handling
  }
}

async function downVote(voteMark: number, votableId: number, votableType: 'Question' | 'Answer' | 'Comment' | 'Course' | 'Lesson') {
  if (voteMark == -1) {
    return
  }
  try {
    const voteForm = new VoteForm()
    voteForm.value = Math.max(voteMark - 1, -1)
    voteForm.votableId = votableId
    voteForm.votableType = votableType
    await api.vote.create(voteForm)
    question.value = await api.userQuestion.show(route.params.questionId as string)
  } catch (e) {
    // Error handling
  }
}

function downloadFile(link: string) {
  window.open(`${location.origin}/${link}`)
}

function formatResolvedDate(dateString: string) {
  if (!dateString) return ''
  const date = new Date(dateString)
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hours = date.getHours()
  const minutes = date.getMinutes()
  return `${year}年${month}月${day}日 ${hours}時${minutes}分`
}

function createCommentChannel() {
  if (!question.value) return
  removeChannel('QuestionCommentChannel')
  channel.value = makeChannel(
    'QuestionCommentChannel',
    async () => {
      getCurrentQuestion()
    },
    () => {
      channel.value.send({
        action: 'follow',
        data: {
          relativeable_id: question.value?.id,
          relativeable_type: 'Question'
        }
      })
    },
  )
}

// Watchers
watch(() => route.params.questionId, async () => {
  try {
    question.value = await api.userQuestion.show(route.params.questionId as string)
    if (question.value) {
      headerState.setTitle(question.value.title)
    }
  } catch (e) {
    // Error handling
  }
})

// Lifecycle
onUpdated(() => {
  nextTick(() => {
    if (route.hash) {
      const el = document.querySelector(route.hash)
      el && el.scrollIntoView()
    }
  })
})

// Created logic
;(async () => {
  try {
    await getCurrentQuestion()
    if (question.value) {
      createCommentChannel()
      headerState.setTitle(question.value.title)

      course.value = question.value.questionRelatives.find((relative) => relative.relativeableType == 'Course') || null
      if (course.value) {
        breadcrumbs.value.push({
          text: stringTruncate(course.value.name, 5),
          disabled: false,
          exact: true,
          to: `/classroom/questions?course_id=${course.value.relativeableId}&type=list`
        })
      }

      lesson.value = question.value.questionRelatives.find((relative) => relative.relativeableType == 'Lesson') || null
      if (lesson.value) {
        breadcrumbs.value.push({
          text: stringTruncate(lesson.value.name, 5),
          disabled: false,
          exact: true,
          to: `/classroom/questions?lesson_id=${lesson.value.relativeableId}&type=list`
        })
      }

      breadcrumbs.value.push({
        text: stringTruncate(question.value.title, 5),
        disabled: true,
        exact: false,
        to: ''
      })
    }
  } catch (e) {
    // Error handling
  }
})()

return (_ctx: any,_cache: any) => {
  const _component_AppBreadcrumb = _resolveComponent("AppBreadcrumb")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_col, {
        lg: "12",
        xs: "12",
        class: "col-xs-12 col-lg-12"
      }, {
        default: _withCtx(() => [
          (question.value)
            ? (_openBlock(), _createBlock(_component_AppBreadcrumb, {
                key: 0,
                items: breadcrumbs.value,
                class: "mb-3"
              }, null, 8 /* PROPS */, ["items"]))
            : _createCommentVNode("v-if", true),
          (question.value)
            ? (_openBlock(), _createBlock(_component_v_card, {
                key: 1,
                variant: "outlined",
                tile: "",
                class: "pt-2 px-4 pb-0 mb-4 bg-white"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_v_col, { cols: "1" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          variant: "tonal",
                          icon: "",
                          size: "small",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (upVote(question.value.voteMark, question.value.id, 'Question'))),
                          class: _normalizeClass({ 'success dark': question.value.voteMark == 1 })
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                _createTextVNode("mdi-chevron-up", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["class"]),
                        _createElementVNode("div", _hoisted_4, _toDisplayString(question.value.voteMark), 1 /* TEXT */),
                        _createVNode(_component_v_btn, {
                          variant: "tonal",
                          icon: "",
                          size: "small",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (downVote(question.value.voteMark, question.value.id, 'Question'))),
                          class: _normalizeClass({ 'success dark': question.value.voteMark == -1 })
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                _createTextVNode("mdi-chevron-down", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["class"])
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_col, { cols: "11" }, {
                      default: _withCtx(() => [
                        (!question.value.isEditing)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (course.value && lesson.value)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: `/classroom/courses/${course.value.relativeableId}?lesson_id=${lesson.value.relativeableId}`,
                                    class: "ms-4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(lesson.value.name), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["to"]))
                                : _createCommentVNode("v-if", true),
                              _createElementVNode("div", _hoisted_5, [
                                _createVNode(_component_v_card_title, { class: "pt-0 question-title flex-grow-1" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(question.value.title) + " ", 1 /* TEXT */),
                                    (question.value.questionType == 'private_question')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, "（プライベート質問）"))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                (question.value.user && question.value.user.id == user.value?.id)
                                  ? (_openBlock(), _createBlock(_component_v_menu, { key: 0 }, {
                                      activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_btn, _mergeProps({
                                          icon: "",
                                          variant: "text",
                                          size: "small"
                                        }, props), {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, null, {
                                              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                                _createTextVNode("mdi-dots-vertical", -1 /* CACHED */)
                                              ]))]),
                                              _: 1 /* STABLE */
                                            })
                                          ]),
                                          _: 1 /* STABLE */
                                        }, 16 /* FULL_PROPS */)
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list, {
                                          density: "compact",
                                          class: "py-0"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item, {
                                              onClick: _cache[2] || (_cache[2] = ($event: any) => (question.value.isEditing = true))
                                            }, {
                                              prepend: _withCtx(() => [
                                                _createVNode(_component_v_icon, { size: "small" }, {
                                                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                                    _createTextVNode("mdi-pencil", -1 /* CACHED */)
                                                  ]))]),
                                                  _: 1 /* STABLE */
                                                })
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                                    _createTextVNode("編集", -1 /* CACHED */)
                                                  ]))]),
                                                  _: 1 /* STABLE */
                                                })
                                              ]),
                                              _: 1 /* STABLE */
                                            }),
                                            _createVNode(_component_v_list_item, {
                                              onClick: _cache[3] || (_cache[3] = ($event: any) => (deleteQuestion(question.value.id))),
                                              class: "text-error"
                                            }, {
                                              prepend: _withCtx(() => [
                                                _createVNode(_component_v_icon, {
                                                  size: "small",
                                                  color: "error"
                                                }, {
                                                  default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                                    _createTextVNode("mdi-delete", -1 /* CACHED */)
                                                  ]))]),
                                                  _: 1 /* STABLE */
                                                })
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                                    _createTextVNode("消去", -1 /* CACHED */)
                                                  ]))]),
                                                  _: 1 /* STABLE */
                                                })
                                              ]),
                                              _: 1 /* STABLE */
                                            })
                                          ]),
                                          _: 1 /* STABLE */
                                        })
                                      ]),
                                      _: 1 /* STABLE */
                                    }))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _createVNode(_component_v_divider, { style: {"margin":"0"} }),
                              _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: "mb-4 html-body",
                                    innerHTML: question.value.renderedBody
                                  }, null, 8 /* PROPS */, _hoisted_7),
                                  _createElementVNode("div", _hoisted_8, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.value.materials, (material) => {
                                      return (_openBlock(), _createBlock(_component_v_col, {
                                        key: material.id,
                                        class: "attachment-col"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_tooltip, { location: "top" }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_card, _mergeProps({
                                                onClick: _withModifiers(($event: any) => (downloadFile(material.link)), ["prevent"])
                                              }, { ref_for: true }, props, { class: "me-2" }), {
                                                default: _withCtx(() => [
                                                  _createElementVNode("div", _hoisted_9, [
                                                    _createVNode(FileIcon, {
                                                      fileName: material.fileName
                                                    }, null, 8 /* PROPS */, ["fileName"])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_10, _toDisplayString(material.fileName), 1 /* TEXT */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                              }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                            ]),
                                            default: _withCtx(() => [
                                              _createElementVNode("span", null, _toDisplayString(material.fileName), 1 /* TEXT */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                          }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1024 /* DYNAMIC_SLOTS */))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ]),
                                  _createElementVNode("div", _hoisted_11, [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      class: "p-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_12, [
                                          _createVNode(_component_v_col, {
                                            cols: "2",
                                            class: "me-2"
                                          }, {
                                            default: _withCtx(() => [
                                              (question.value.user && question.value.user.image)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: question.value.user.image.url,
                                                    style: {"width":"40px"}
                                                  }, null, 8 /* PROPS */, _hoisted_13))
                                                : _createCommentVNode("v-if", true)
                                            ]),
                                            _: 1 /* STABLE */
                                          }),
                                          _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => [
                                              (question.value.user)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(question.value.user.name), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true),
                                              _createElementVNode("div", _hoisted_15, _toDisplayString(question.value.createdAt.substring(0, 10)) + "に質問しました", 1 /* TEXT */)
                                            ]),
                                            _: 1 /* STABLE */
                                          })
                                        ])
                                      ]),
                                      _: 1 /* STABLE */
                                    })
                                  ]),
                                  _createVNode(_component_v_divider),
                                  _createVNode(_component_v_list, {
                                    "three-line": "",
                                    density: "compact"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.value.comments, (comment) => {
                                        return (_openBlock(), _createBlock(CommentComponent, {
                                          key: comment.id,
                                          id: `comment-${comment.id}`,
                                          class: "px-0",
                                          comment: comment,
                                          user: user.value,
                                          deleteComment: deleteComment,
                                          updateComment: updateComment
                                        }, null, 8 /* PROPS */, ["id", "comment", "user"]))
                                      }), 128 /* KEYED_FRAGMENT */))
                                    ]),
                                    _: 1 /* STABLE */
                                  }),
                                  (!question.value.resolvedAt)
                                    ? (_openBlock(), _createBlock(CommentCreation, {
                                        key: 0,
                                        showCommentForm: question.value.showCommentForm,
                                        createComment: createComment,
                                        onCancel: ()=>{question.value.showCommentForm = false},
                                        onOpen: ()=>{question.value.showCommentForm = true}
                                      }, null, 8 /* PROPS */, ["showCommentForm", "onCancel", "onOpen"]))
                                    : _createCommentVNode("v-if", true)
                                ]),
                                _: 1 /* STABLE */
                              })
                            ], 64 /* STABLE_FRAGMENT */))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createVNode(Simplemde, {
                                modelValue: question.value.body,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((question.value.body) = $event)),
                                rows: 3,
                                name: "answer-new"
                              }, null, 8 /* PROPS */, ["modelValue"]),
                              _createElementVNode("div", _hoisted_16, [
                                (user.value && user.value.hasActiveSubscription)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 0,
                                      lg: "12"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_checkbox, {
                                          modelValue: question.value.questionType,
                                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((question.value.questionType) = $event)),
                                          label: "プライベート質問 ＊この質問は一般には公開されません",
                                          "true-value": "private_question",
                                          "false-value": "nomal_question",
                                          class: "my-0",
                                          "hide-details": ""
                                        }, null, 8 /* PROPS */, ["modelValue"])
                                      ]),
                                      _: 1 /* STABLE */
                                    }))
                                  : _createCommentVNode("v-if", true),
                                _createVNode(_component_v_col, { lg: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_file_input, {
                                      modelValue: question.value.files,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((question.value.files) = $event)),
                                      label: "素材をアップロード",
                                      multiple: "",
                                      "prepend-icon": "mdi-paperclip"
                                    }, {
                                      selection: _withCtx(({ fileNames }) => [
                                        _createVNode(_component_v_chip, {
                                          size: "small",
                                          label: "",
                                          color: "primary"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(fileNames.join(', ')), 1 /* TEXT */)
                                          ]),
                                          _: 2 /* DYNAMIC */
                                        }, 1024 /* DYNAMIC_SLOTS */)
                                      ]),
                                      _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue"])
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _createElementVNode("div", _hoisted_17, [
                                _createVNode(_component_v_btn, {
                                  color: "primary",
                                  class: "px-4",
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (updateQuestion(question.value)))
                                }, {
                                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                    _createTextVNode("質問を投稿する", -1 /* CACHED */)
                                  ]))]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_btn, {
                                  variant: "outlined",
                                  class: "px-4",
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (question.value.isEditing = false))
                                }, {
                                  default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                    _createTextVNode("キャンセル", -1 /* CACHED */)
                                  ]))]),
                                  _: 1 /* STABLE */
                                })
                              ])
                            ], 64 /* STABLE_FRAGMENT */))
                      ]),
                      _: 1 /* STABLE */
                    })
                  ])
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true),
          _withDirectives(_createElementVNode("h2", _hoisted_18, "アンサー", 512 /* NEED_PATCH */), [
            [_vShow, question.value && question.value.userAnswers.length > 0]
          ]),
          (question.value && question.value.userAnswers.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.value.userAnswers, (answer, answerIndex) => {
                  return (_openBlock(), _createBlock(_component_v_card, {
                    variant: "outlined",
                    tile: "",
                    key: answer.id,
                    id: `answer-${answer.id}`,
                    class: "pt-2 px-4 pb-0 mb-5"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_v_col, { cols: "1" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              variant: "tonal",
                              icon: "",
                              size: "small",
                              onClick: ($event: any) => (upVote(answer.voteMark, answer.id, 'Answer')),
                              class: _normalizeClass(answer.voteMark == 1 ? 'success dark' : '')
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                    _createTextVNode("mdi-chevron-up", -1 /* CACHED */)
                                  ]))]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick", "class"]),
                            _createElementVNode("div", _hoisted_21, _toDisplayString(answer.voteMark), 1 /* TEXT */),
                            _createVNode(_component_v_btn, {
                              variant: "tonal",
                              icon: "",
                              size: "small",
                              onClick: ($event: any) => (downVote(answer.voteMark, answer.id, 'Answer')),
                              class: _normalizeClass(answer.voteMark == -1 ? 'success dark' : '')
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                    _createTextVNode("mdi-chevron-down", -1 /* CACHED */)
                                  ]))]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick", "class"])
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */),
                        _createVNode(_component_v_col, { cols: "11" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "pt-0" }, {
                              default: _withCtx(() => [
                                (!answer.isEditing)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createCommentVNode(" Answer Header: Best Answer Button + Kebab Menu "),
                                      _createElementVNode("div", _hoisted_22, [
                                        (answer.user && question.value.user.id == user.value?.id)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              (answer.accepted)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                    _createVNode(_component_v_btn, {
                                                      color: "danger",
                                                      onClick: ($event: any) => (setBestAnswer(answer, 'false'))
                                                    }, {
                                                      default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                                        _createTextVNode("ベストアンサーを取り消す", -1 /* CACHED */)
                                                      ]))]),
                                                      _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                                    _createVNode(_component_v_btn, {
                                                      color: "primary",
                                                      onClick: ($event: any) => (setBestAnswer(answer, 'true'))
                                                    }, {
                                                      default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                                        _createTextVNode("ベストアンサーにする!", -1 /* CACHED */)
                                                      ]))]),
                                                      _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["onClick"])
                                                  ]))
                                            ], 64 /* STABLE_FRAGMENT */))
                                          : (answer.accepted)
                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 1,
                                                color: "success"
                                              }, {
                                                default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                                  _createTextVNode("ベストアンサー", -1 /* CACHED */)
                                                ]))]),
                                                _: 1 /* STABLE */
                                              }))
                                            : _createCommentVNode("v-if", true),
                                        _createCommentVNode(" Kebab Menu "),
                                        (answer.user && answer.user.id == user.value?.id)
                                          ? (_openBlock(), _createBlock(_component_v_menu, { key: 2 }, {
                                              activator: _withCtx(({ props }) => [
                                                _createVNode(_component_v_btn, _mergeProps({
                                                  icon: "",
                                                  variant: "text",
                                                  size: "small"
                                                }, { ref_for: true }, props), {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_icon, null, {
                                                      default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                                        _createTextVNode("mdi-dots-vertical", -1 /* CACHED */)
                                                      ]))]),
                                                      _: 1 /* STABLE */
                                                    })
                                                  ]),
                                                  _: 1 /* STABLE */
                                                }, 16 /* FULL_PROPS */)
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list, {
                                                  density: "compact",
                                                  class: "py-0"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item, {
                                                      onClick: ($event: any) => (answer.isEditing = true)
                                                    }, {
                                                      prepend: _withCtx(() => [
                                                        _createVNode(_component_v_icon, { size: "small" }, {
                                                          default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                                            _createTextVNode("mdi-pencil", -1 /* CACHED */)
                                                          ]))]),
                                                          _: 1 /* STABLE */
                                                        })
                                                      ]),
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_list_item_title, null, {
                                                          default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                                            _createTextVNode("編集", -1 /* CACHED */)
                                                          ]))]),
                                                          _: 1 /* STABLE */
                                                        })
                                                      ]),
                                                      _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["onClick"]),
                                                    _createVNode(_component_v_list_item, {
                                                      onClick: ($event: any) => (deleteAnswer(answer.id)),
                                                      class: "text-error"
                                                    }, {
                                                      prepend: _withCtx(() => [
                                                        _createVNode(_component_v_icon, {
                                                          size: "small",
                                                          color: "error"
                                                        }, {
                                                          default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                                                            _createTextVNode("mdi-delete", -1 /* CACHED */)
                                                          ]))]),
                                                          _: 1 /* STABLE */
                                                        })
                                                      ]),
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_list_item_title, null, {
                                                          default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                                                            _createTextVNode("消去", -1 /* CACHED */)
                                                          ]))]),
                                                          _: 1 /* STABLE */
                                                        })
                                                      ]),
                                                      _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["onClick"])
                                                  ]),
                                                  _: 2 /* DYNAMIC */
                                                }, 1024 /* DYNAMIC_SLOTS */)
                                              ]),
                                              _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */))
                                          : _createCommentVNode("v-if", true)
                                      ]),
                                      _createCommentVNode(" Answer Content "),
                                      _createElementVNode("div", {
                                        class: "html-body",
                                        innerHTML: answer.renderedBody
                                      }, null, 8 /* PROPS */, _hoisted_25),
                                      _createElementVNode("div", _hoisted_26, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answer.materials, (material) => {
                                          return (_openBlock(), _createBlock(_component_v_col, {
                                            key: material.id,
                                            class: "attachment-col"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_tooltip, { location: "top" }, {
                                                activator: _withCtx(({ props }) => [
                                                  _createVNode(_component_v_card, _mergeProps({
                                                    onClick: _withModifiers(($event: any) => (downloadFile(material.link)), ["prevent"])
                                                  }, { ref_for: true }, props, { class: "me-2" }), {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("div", _hoisted_27, [
                                                        _createVNode(FileIcon, {
                                                          fileName: material.fileName
                                                        }, null, 8 /* PROPS */, ["fileName"])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_28, _toDisplayString(material.fileName), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                  }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                ]),
                                                default: _withCtx(() => [
                                                  _createElementVNode("span", null, _toDisplayString(material.fileName), 1 /* TEXT */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                              }, 1024 /* DYNAMIC_SLOTS */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                          }, 1024 /* DYNAMIC_SLOTS */))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ])
                                    ], 64 /* STABLE_FRAGMENT */))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createVNode(Simplemde, {
                                        modelValue: answer.body,
                                        "onUpdate:modelValue": ($event: any) => ((answer.body) = $event),
                                        rows: 3,
                                        name: "answer-new"
                                      }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]),
                                      _createElementVNode("div", _hoisted_29, [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_file_input, {
                                              modelValue: answer.files,
                                              "onUpdate:modelValue": ($event: any) => ((answer.files) = $event),
                                              label: "素材をアップロード",
                                              multiple: "",
                                              "prepend-icon": "mdi-paperclip"
                                            }, {
                                              selection: _withCtx(({ fileNames }) => [
                                                _createVNode(_component_v_chip, {
                                                  size: "small",
                                                  label: "",
                                                  color: "primary"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(fileNames.join(', ')), 1 /* TEXT */)
                                                  ]),
                                                  _: 2 /* DYNAMIC */
                                                }, 1024 /* DYNAMIC_SLOTS */)
                                              ]),
                                              _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _: 2 /* DYNAMIC */
                                        }, 1024 /* DYNAMIC_SLOTS */)
                                      ]),
                                      _createElementVNode("div", _hoisted_30, [
                                        _createVNode(_component_v_btn, {
                                          color: "primary",
                                          class: "px-4",
                                          onClick: ($event: any) => (updateAnswer(answer))
                                        }, {
                                          default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                                            _createTextVNode("アンサーを送信する", -1 /* CACHED */)
                                          ]))]),
                                          _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["onClick"]),
                                        _createVNode(_component_v_btn, {
                                          variant: "outlined",
                                          class: "px-4",
                                          onClick: ($event: any) => (answer.isEditing = false)
                                        }, {
                                          default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                                            _createTextVNode("キャンセル", -1 /* CACHED */)
                                          ]))]),
                                          _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["onClick"])
                                      ])
                                    ], 64 /* STABLE_FRAGMENT */)),
                                _createElementVNode("div", _hoisted_31, [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    class: "p-0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_32, [
                                        _createVNode(_component_v_col, {
                                          cols: "2",
                                          class: "me-2"
                                        }, {
                                          default: _withCtx(() => [
                                            (answer.user && answer.user.image)
                                              ? (_openBlock(), _createElementBlock("img", {
                                                  key: 0,
                                                  src: answer.user.image.url,
                                                  style: {"width":"40px"}
                                                }, null, 8 /* PROPS */, _hoisted_33))
                                              : _createCommentVNode("v-if", true)
                                          ]),
                                          _: 2 /* DYNAMIC */
                                        }, 1024 /* DYNAMIC_SLOTS */),
                                        _createVNode(_component_v_col, null, {
                                          default: _withCtx(() => [
                                            (answer.user)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(answer.user.name), 1 /* TEXT */))
                                              : _createCommentVNode("v-if", true),
                                            _createElementVNode("div", _hoisted_35, _toDisplayString(answer.createdAt.substring(0, 10)) + "にアンサーしました", 1 /* TEXT */)
                                          ]),
                                          _: 2 /* DYNAMIC */
                                        }, 1024 /* DYNAMIC_SLOTS */)
                                      ])
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */)
                                ]),
                                _createVNode(_component_v_divider),
                                _createVNode(_component_v_list, { density: "compact" }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answer.comments, (comment) => {
                                      return (_openBlock(), _createBlock(CommentComponent, {
                                        key: comment.id,
                                        id: `comment-${comment.id}`,
                                        class: "px-0",
                                        comment: comment,
                                        user: user.value,
                                        deleteComment: deleteComment,
                                        updateComment: updateComment
                                      }, null, 8 /* PROPS */, ["id", "comment", "user"]))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */),
                                (!question.value.resolvedAt)
                                  ? (_openBlock(), _createBlock(CommentCreation, {
                                      key: 2,
                                      showCommentForm: answer.showCommentForm,
                                      onCancel: ()=>{answer.showCommentForm = false},
                                      onOpen: ()=>{answer.showCommentForm = true},
                                      createComment: 
                      (newComment) => {
                        createAnswerComment(newComment, answer)
                      }
                    
                                    }, null, 8 /* PROPS */, ["showCommentForm", "onCancel", "onOpen", "createComment"]))
                                  : _createCommentVNode("v-if", true),
                                (answerIndex === question.value.userAnswers.length - 1 && question.value.user.id == user.value?.id && !question.value.resolvedAt)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 3,
                                      color: "success",
                                      onClick: resolveQuestion
                                    }, {
                                      default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                                        _createTextVNode(" 解決しました！ ", -1 /* CACHED */)
                                      ]))]),
                                      _: 1 /* STABLE */
                                    }))
                                  : _createCommentVNode("v-if", true),
                                _createCommentVNode(" Resolved Status - show on last answer if resolved "),
                                (answerIndex === question.value.userAnswers.length - 1 && question.value.resolvedAt)
                                  ? (_openBlock(), _createBlock(_component_v_alert, {
                                      key: 4,
                                      type: "success",
                                      class: "mt-3 mb-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _cache[35] || (_cache[35] = _createElementVNode("strong", null, "解決済み", -1 /* CACHED */)),
                                        _createTextVNode(" - " + _toDisplayString(formatResolvedDate(question.value.resolvedAt)), 1 /* TEXT */)
                                      ]),
                                      _: 1 /* STABLE */
                                    }))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */)
                      ])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          (question.value && !question.value.resolvedAt)
            ? (_openBlock(), _createBlock(_component_v_card, {
                key: 3,
                variant: "outlined",
                tile: "",
                class: "p-4 bg-white"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "headline px-0 pt-0" }, {
                    default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                      _createTextVNode("アンサーを投稿", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(Simplemde, {
                    modelValue: newAnswer.value,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((newAnswer).value = $event)),
                    rows: 3,
                    name: "answer-body"
                  }, null, 8 /* PROPS */, ["modelValue"]),
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_file_input, {
                          modelValue: answerFiles.value,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((answerFiles).value = $event)),
                          label: "素材をアップロード",
                          multiple: "",
                          "prepend-icon": "mdi-paperclip"
                        }, {
                          selection: _withCtx(({ fileNames }) => [
                            _createVNode(_component_v_chip, {
                              size: "small",
                              label: "",
                              color: "primary"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(fileNames.join(', ')), 1 /* TEXT */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */)
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    class: "me-2",
                    onClick: createAnswer
                  }, {
                    default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                      _createTextVNode("アンサーを送信する", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createVNode(ConfirmDialog, {
      ref_key: "confirmRef",
      ref: confirmRef
    }, null, 512 /* NEED_PATCH */),
    _createVNode(_component_v_snackbar, {
      modelValue: showSuccessSnackbar.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((showSuccessSnackbar).value = $event)),
      color: "success",
      location: "top right",
      timeout: 4000,
      style: { zIndex: 9999 },
      rounded: "lg",
      "min-width": "280"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          icon: "",
          variant: "text",
          color: "white",
          size: "small",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (showSuccessSnackbar.value = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { size: "18" }, {
              default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                _createTextVNode("mdi-close", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_37, [
          _createVNode(_component_v_icon, {
            size: "20",
            color: "white"
          }, {
            default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
              _createTextVNode("mdi-check-circle", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }),
          _cache[39] || (_cache[39] = _createElementVNode("span", { class: "text-white text-body-2 font-weight-medium" }, "アンサーを送信しました！", -1 /* CACHED */))
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ]))
}
}

})